import React from 'react';
import { Helmet } from 'react-helmet';

import { spanish } from '../../../config/config';
import BillingForm from '../../../components/Billing/Form';

const BillingFormPage = () => (
  <>
    <Helmet title={spanish ? 'Facturación' : 'Billing'} />
    <BillingForm />
  </>
);

export default BillingFormPage;
